import API from '@/shared/plugins/Api/API'
import Actions from './Actions'
import Deployments from './Deployments'
import { environmentModel, Environments } from './Environments'
import Events from './Events'
import Jobs from './Jobs'
import Quotas from './Quotas'
import Repositories from './Repositories'
import SparkHistory from './SparkHistory'
import Workflows from './Workflows'

class DPE extends API {
  constructor (id) {
    super(id)
    this.actions = new Actions(id)
    this.deployments = new Deployments(id)
    this.repositories = new Repositories(id)
    this.environments = new Environments(id)
    this.environmentModel = environmentModel
    this.events = new Events(id)
    this.workflows = new Workflows(id)
    this.jobs = new Jobs(id)
    this.quotas = new Quotas(id)
    this.sparkHistory = new SparkHistory(id)
  }

  templatesActionsAggregate (source, destination, action) {
    return this.request({
      method: 'GET',
      url: '/v3/templates/actions/aggregate',
      params: {
        source_db: source.database_name,
        source: source.table_name,
        destination_db: destination.database_name,
        destination: destination.table_name,
        action: action
      }
    })
  }

  fetchRepositoryBranches (url) {
    return this.request({
      method: 'GET',
      url: '/v3/git/branches/list',
      params: {
        url: url
      }
    })
  }

  fetchPublicKey () {
    return this.request({
      method: 'GET',
      url: '/v3/git/public_key'
    })
  }

  // Action boilerplates
  customActionBoilerplate (language = 'python') {
    return this.request({
      method: 'GET',
      url: '/v3/templates/actions/custom',
      params: {
        language: language
      }
    })
  }

  // Custom Action helper content (examples, SDK reference, FAQ) served by the
  // DPE backend so the DPE team owns the content. The Helpers panel falls back
  // to its bundled catalog if this is unavailable.
  fetchHelpersContent () {
    return this.request({
      method: 'GET',
      url: '/v3/helpers/content'
    })
  }

  async import (item) {
    return this.request({
      method: 'POST',
      url: 'v4/backup/import',
      data: item,
      timeout: 60 * 10 * 1000
    })
  }

  // GET the configuration archive as a blob so the download happens in-app (with progress feedback).
  async exportConfiguration () {
    return this.request({
      method: 'GET',
      url: 'v3/configuration/export',
      responseType: 'blob',
      originalResponse: true,
      timeout: 60 * 10 * 1000
    })
  }

  // Mirror of the export endpoint (GET v3/configuration/export) used on the project home tiles.
  async importConfiguration (file) {
    const formData = new FormData()
    formData.append('archive', file)
    return this.request({
      method: 'POST',
      url: 'v3/configuration/import',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60 * 10 * 1000
    })
  }

  // Import a configuration archive hosted at a URL (DPE supports sourceType=url / sourceParam).
  async importConfigurationFromUrl (url) {
    return this.request({
      method: 'POST',
      url: 'v3/configuration/import',
      params: { sourceType: 'url', sourceParam: url },
      timeout: 60 * 10 * 1000
    })
  }
}
export default DPE
